import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { withLatestFrom } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as globalActions from '../../../store/global/global.actions';
import { UserService } from '../service/user.service';
import { EffectFactory } from './common/effect.factory';
import * as actions from './shared.actions';
import { selectTableRefreshers } from './shared.selectors';

@Injectable()
export class SharedEffects {
    private readonly actions$ = inject(Actions);
    private readonly store = inject(Store);
    private readonly api = inject(UserService);


    factory = new EffectFactory(this.actions$, actions, this.api).create();

    refreshTable$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(globalActions.globalSuccess),
                withLatestFrom(this.store.select(selectTableRefreshers)),
                tap(([{ input: { key } }, refreshers]) => {
                        Object.keys(refreshers).forEach((table) => {
                            if (refreshers[table].includes(key)) {
                                this.store.dispatch(actions.refreshTable({ table }));
                            }
                        });
                    },
                ),
            ),
        { dispatch: false },
    );

}
